const roleGroup = [{
  desc: '获取角色组分类',
  options: {
    url: '/roleGroup/queryRoleGroupType',
    method: 'get',
    argsParams: true
  }
}, {
  desc: '获取指定平台的角色组数据',
  options: {
    url: '/roleGroup/queryRoleGroupBySysType',
    method: 'get',
    argsParams: true
  }
}, {
  desc: '获取指定平台的角色组数据',
  options: {
    url: '/roleGroup/queryRoleGroupByOrgType',
    method: 'POST'
  }
}]
export default roleGroup



// WEBPACK FOOTER //
// ./src/api/roleGroup.js